import { ImageSourcePropType } from 'react-native';
import coverWhaleLogo from 'src/assets/coverWhale.png';
import amicLogo from 'src/assets/carriers/amic.png';
import tenFourLogo from 'src/assets/carriers/tenfour.png';

/**
 * Maps carrier IDs to their corresponding logo assets
 * This is used to dynamically display the correct carrier logo on quote cards
 */
export const CARRIER_IDS = {
  COVERWHALE: 1,
  AMIC: 2,
  TENFOUR: 3,
  // Add more carrier IDs as needed
} as const;

const logoMap: Record<number, ImageSourcePropType> = {
  [CARRIER_IDS.COVERWHALE]: coverWhaleLogo,
  [CARRIER_IDS.AMIC]: amicLogo,
  [CARRIER_IDS.TENFOUR]: tenFourLogo,
};

export const getCarrierLogo = (carrierId: number | undefined): ImageSourcePropType => {
  if (!carrierId) {
    return coverWhaleLogo;
  }
  return logoMap[carrierId] || coverWhaleLogo;
};
